module.exports = __webpack_public_path__ + "img/equal_b.3d205228.svg";